import request from '@/utils/httpRequest'
/*
 * @author: xz
 * */
/*
 * @Description: 资讯列表
 * */
export function getInformationList (query) {
  return request({
    url: '/api/information/web/page',
    method: 'get',
    params: query
  })
}
/*
 * @Description: 资讯详情
 * */
export function getInformationDetail (id) {
  return request({
    url: '/api/information/web/' + id,
    method: 'get'
  })
}
/*
 * @Description: 图书推荐
 * */
export function getbook (query) {
  return request({
    url: '/api/information/web/book',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/information/index.js